module.exports = __webpack_public_path__ + "static/05-c82222c6bcc2aeeb19aa349783201097.jpg";